module.exports = __webpack_public_path__ + "static/img/projectService_3.58dc846.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainPage/projectService_3.jpg
// module id = F61L
// module chunks = 0